

import { useEffect, useState } from "react";
import { useLocation,Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa"; // Importing icons from react-icons
import { BiBorderBottom } from "react-icons/bi";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [active, setActive] = useState("About Us");
  const location = useLocation();
  //console.log(location.pathname);
  useEffect(() => {
    setActive(location.pathname);
  }, []);

  const menuItems = [
    { text: "About Us", href: "/about" },
    { text: "Careers", href: "/careers" },
    { text: "Newsroom", href: "/press" },
    { text: "Alumni Speak", href: "/review" },
    { text: "Contact Us", href: "/contact" },
  ];

  return (
    <div className="bg-[#008ba0] w-full z-20 shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Desktop Menu */}
          <div className="hidden md:block">
            <div className="flex space-x-8">
              {menuItems?.map((item) => (
                <Link
                  key={item.text}
                  to={item.href}
                  onClick={() => setActive(item.href)}
                  className={`px-3 py-2 text-sm font-medium transition-colors relative ${active === item.href
                    ? "text-orange-400"
                    : "hover:text-orange-400"
                    }`}
                  style={{
                    color: "white",
                    borderBottom: active === item.href ? "2px solid orange" : "none",
                    backgroundColor: active === item.href ? "#333333" : "transparent"
                  }}
                >
                  {item.text}
                </Link>
              ))}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white hover:text-orange-400 p-2"
            >
              {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-[#002868] shadow-md">
          <div className="px-2 pt-2 pb-3 space-y-1 text-white">
            {menuItems?.map((item) => (
              <a
                key={item.text}
                href={item.href}
                onClick={() => {
                  setActive(item.text);
                  setIsMenuOpen(false);
                }}
                className={`block px-3 py-2 text-base font-medium transition-colors ${active === item.text
                  ? "text-orange-400"
                  : "text-white hover:text-orange-400"
                  }`}
                style={{ color: "white" }}
              >
                {item.text}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
